import { useState } from "react";
import Notebook from "../Notebook/Notebook";
import Calendar from "../Calendar/Calendar";
import Reminders from "../Reminders/Reminders";
import Ideas from "../Ideas/Ideas";
import Researches from "../Researches/Researches";
import Devices from "../Devices/Devices";
import "./Workspace.css";

function Workspace() {
  const validTabs = ["notebook", "calendar", "reminders", "ideas", "researches", "devices"];
  const hashTab = window.location.hash.replace("#", "");
  const [tab, setTab] = useState(validTabs.includes(hashTab) ? hashTab : "notebook");

  const switchTab = (t) => { setTab(t); window.location.hash = t; };

  return (
    <div className="workspace-page">
      <div className="workspace-header">
        <h2>Workspace</h2>
      </div>

      <div className="tab-bar">
        <button
          className={`tab ${tab === "notebook" ? "active" : ""}`}
          onClick={() => switchTab("notebook")}
        >
          📓 Notebook
        </button>
        <button
          className={`tab ${tab === "calendar" ? "active" : ""}`}
          onClick={() => switchTab("calendar")}
        >
          📅 Calendar
        </button>
        <button
          className={`tab ${tab === "reminders" ? "active" : ""}`}
          onClick={() => switchTab("reminders")}
        >
          🔔 Reminders
        </button>
        <button
          className={`tab ${tab === "ideas" ? "active" : ""}`}
          onClick={() => switchTab("ideas")}
        >
          💡 Ideas
        </button>
        <button
          className={`tab ${tab === "researches" ? "active" : ""}`}
          onClick={() => switchTab("researches")}
        >
          🔍 Researches
        </button>
        <button
          className={`tab ${tab === "devices" ? "active" : ""}`}
          onClick={() => switchTab("devices")}
        >
          🏠 Devices
        </button>
      </div>

      {tab === "notebook" ? <Notebook /> :
        tab === "calendar" ? <Calendar /> :
        tab === "reminders" ? <Reminders /> :
        tab === "ideas" ? <Ideas /> :
        tab === "researches" ? <Researches /> :
        <Devices />}
    </div>
  );
}

export default Workspace;
